import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import { TourProvider } from './contexts/TourContext';
import { RealtimeProvider } from './contexts/RealtimeContext';
import ProtectedRoute from './components/ProtectedRoute';

// Admin pages
import AdminLayout from './pages/admin/AdminLayout';
import LoginPage from './pages/admin/LoginPage';
// import SignupPage from './pages/admin/SignupPage';
import ForgotPasswordPage from './pages/admin/ForgotPasswordPage';
import ResetPasswordPage from './pages/admin/ResetPasswordPage';
import DashboardPage from './pages/admin/DashboardPage';
import ProductsPage from './pages/admin/ProductsPage';
import WheelsPage from './pages/admin/WheelsPage';
import ThemesPage from './pages/admin/ThemesPage';
import LeadsPage from './pages/admin/LeadsPage';
import ReportsPage from './pages/admin/ReportsPage';
import UsersPage from './pages/admin/UsersPage';
import SubscriptionPage from './pages/admin/SubscriptionPage';
import CompanySettingsPage from './pages/admin/CompanySettingsPage';
import UserProfilePage from './pages/admin/UserProfilePage';
import WhatsappPage from './pages/admin/WhatsappPage';
import WhatsAppTermsPage from './pages/admin/WhatsAppTermsPage';
import ManualDrawPage from './pages/admin/ManualDrawPage';
import NotificationsPage from './pages/admin/NotificationsPage';

// Public pages
import WheelPage from './pages/public/WheelPage';

function App() {
  return (
    <AuthProvider>
      <Router>
        <TourProvider>
          <div className="App">
            <Routes>
              {/* Public routes */}
              <Route path="/w/:companySlug/:slug" element={<WheelPage />} />


              {/* Admin routes */}
              <Route path="/" element={<LoginPage />} />
              {/* <Route path="/signup" element={<SignupPage />} /> */}
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />

              <Route path="/admin" element={
                <ProtectedRoute>
                  <RealtimeProvider>
                    <AdminLayout />
                  </RealtimeProvider>
                </ProtectedRoute>
              }>
                <Route index element={<DashboardPage />} />
                <Route path="products" element={<ProductsPage />} />
                <Route path="wheels" element={<WheelsPage />} />
                <Route path="manual-draw" element={<ManualDrawPage />} />
                <Route path="themes" element={<ThemesPage />} />
                <Route path="leads" element={<LeadsPage />} />
                <Route path="whatsapp" element={<WhatsappPage />} />
                <Route path="reports" element={<ReportsPage />} />
                <Route path="users" element={<UsersPage />} />
                <Route path="subscription" element={<SubscriptionPage />} />
                <Route path="settings" element={<CompanySettingsPage />} />
                <Route path="profile" element={<UserProfilePage />} />
                <Route path="whatsapp-terms" element={<WhatsAppTermsPage />} />
                <Route path="notifications" element={<NotificationsPage />} />
              </Route>

              {/* 404 */}
              <Route path="*" element={
                <div className="min-h-screen flex items-center justify-center bg-gray-100">
                  <div className="text-center">
                    <h1 className="text-4xl font-bold text-gray-900 mb-4">404</h1>
                    <p className="text-gray-600">Página não encontrada</p>
                  </div>
                </div>
              } />
            </Routes>

            <Toaster
              position="top-right"
              toastOptions={{
                duration: 4000,
                style: {
                  background: '#363636',
                  color: '#fff',
                },
                success: {
                  duration: 3000,
                  iconTheme: {
                    primary: '#22c55e',
                    secondary: '#fff',
                  },
                },
                error: {
                  duration: 5000,
                  iconTheme: {
                    primary: '#ef4444',
                    secondary: '#fff',
                  },
                },
              }}
            />
          </div>
        </TourProvider>
      </Router>
    </AuthProvider>
  );
}

export default App;
